import $ from 'jquery';
import { getParams } from '../util/urlParam';
import { exhibitioninfo, langList } from '../variables';
import { createParams } from '../util/urlParam';
import { checkvipcodeJqXHR } from '../api';
import {  userflag } from '../variables';
import translate, { Lang, t } from '../util/translate';
import { confexhi } from '../util/common';

$(() => {
  $('#loading').show(); // ロードを開始
  translate(); // 翻訳
  let exhibition = String(localStorage.getItem('exhibition'));
  confexhi(exhibition, 1).then(exhibitionName => {
    if (exhibitionName === "") {
      window.location.href = `../selection.html`;
    }
  });

  // クエリ取得
  const params = getParams(exhibitioninfo);

  // 言語設定 クエリ優先 -> localStorage
  let lang = 'ja' as keyof Lang
  if (langList.indexOf(String(params.lang)) !== -1) {
    lang = params.lang as keyof Lang;
    localStorage.setItem('lang', lang);
  }else{
    lang = (localStorage.getItem('lang') ?? 'ja') as keyof Lang;
  }

  // フッター問い合わせ
  let contactlist: string = 
  `
  <dd><span>`+ t.footer_tigs[lang] + t.footertel_tigs[lang] +`</span> <a href="mailto:`+ t.footermail_tigs[lang] +`">`+ t.footermail_tigs[lang] +`</a>)</dd>
  <dd><span>`+ t.footer_ld[lang] + t.footertel_ld[lang] +`</span> <a href="mailto:`+ t.footermail_ld[lang] +`">`+ t.footermail_ld[lang] +`</a>)</dd>
  <dd><span>`+ t.footer_landd[lang] + t.footertel_landd[lang] +`</span> <a href="mailto:`+ t.footermail_landd[lang] +`">`+ t.footermail_landd[lang] +`</a>)</dd>
  <dd><span>`+ t.footer_gds[lang] + t.footertel_gds[lang] +`</span> <a href="mailto:`+ t.footermail_gds[lang] +`">`+ t.footermail_gds[lang] +`</a>)</dd>
  <dd><span>`+ t.footer_pi[lang] + t.footertel_pi[lang] +`</span> <a href="mailto:`+ t.footermail_pi[lang] +`">`+ t.footermail_pi[lang] +`</a>)</dd>
  <dd><span>`+ t.footer_osaka[lang] + t.footertel_osaka[lang] +`</span> <a href="mailto:`+ t.footermail_osaka[lang] +`">`+ t.footermail_osaka[lang] +`</a>)</dd>
  <dd><span>`+ t.footer_fukuoka[lang] + t.footertel_fukuoka[lang] +`</span> <a href="mailto:`+ t.footermail_fukuoka[lang] +`">`+ t.footermail_fukuoka[lang] +`</a>)</dd>
  `
  $('#box_officework').html(contactlist);

  // 登録者はこちらリンク
  let hereURL: string =
    '<a href="'+ process.env.GIFT_NET_URL + t.herelogin[lang] + '">' + t.loginurl[lang] + '</a>';
  $('#herelogin').html(hereURL);


  // （VIP）コードチェック
  const codeCheck = () => {
    const freeword = $('#code').val() as string;
    let forms = document.getElementsByClassName('needs-validation');
    const code = $('#code').val() as string + "-" + $('#code2').val() as string;
    let urlParam: string = "";
    checkvipcodeJqXHR(code)
      .done(function (data1, textStatus, jqXHR) {
        if (data1.type === true) {
          // ページ移動とURL作成
          urlParam = createParams({
            userflag: userflag.vip,
            code: code
          });
          localStorage.setItem('vipParam', userflag.vip);
          localStorage.setItem('codeParam', code);
        };
      }).fail(function (jqXHR, textStatus, errorThrown) {
        if (jqXHR.status === 409) {
          urlParam = createParams({
            userflag: userflag.member,
            code: code
          });
          localStorage.setItem('vipParam', userflag.member);
          localStorage.setItem('codeParam', code);
        }
        // 7. alwaysは、成功/失敗に関わらず実行される
      }).always(function () {
        if (urlParam) {
          window.location.href = `./signup.html`;
        }
      });
  };

  const validationCheck = () => {
    let resp: boolean = false;
    let forms = document.getElementsByClassName('needs-validation');
    Array.prototype.filter.call(forms, function (form) {
      if (form.checkValidity() === false) {
        form.classList.add('was-validated');
      } else {
        resp = true;
      }
    });
    return resp;
  }

  $('#get-code-btn').on('click', () => {
    if (validationCheck()) {
      codeCheck();
    }
  });

  $('.vipcode').on('keypress', (e) => {
    if (e.which === 13) validationCheck();
  });
  // コードなしで登録に進む場合
  $('.not-code-btn').on('click', () => {
    localStorage.setItem('vipParam', userflag.general);
    localStorage.setItem('codeParam', "");
    window.location.href = `./signup.html`;
  });

  $('#loading').hide(); // ロードを解除

});
